
import { defineComponent, ref, computed } from "vue";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default defineComponent({
  name: "realestate-fieldmap-modal",
  components: {},
  props: {
    formType: String,
    dataFields: Array,
    isLoading: Boolean,
    isCompleted: Boolean,
  },
  watch: {
    dataFields() {
      this.reset = 0;
    },
    isLoading(val) {
      this.loading = val;
    },
    isCompleted(val) {
      if (val) {
        this.completedImport();
      }
    },
  },
  data: function () {
    return {
      options: {
        draggable: ".item",
        dropzone: ".dropzone",
      },
    };
  },
  methods: {
    droppingStop: function (e) {
      var zoneType = e.dropzone.attributes["type"].value;
      var index = e.dropzone.attributes["data-index"].value;
      var fieldName = e.dragEvent.source.attributes["data-fieldname"].value;

      if (zoneType == "group") {
        if (this.groups[index].item == "") {
          var prev_groups = this.groups.filter(
            (group) => group.item === fieldName
          );
          if (prev_groups.length > 0) prev_groups[0].item = "";
          this.groups[index].item = fieldName;

          prev_groups = this.groups4Import.filter(
            (group) => group.item === fieldName
          );
          if (prev_groups.length > 0) prev_groups[0].item = "";
        }
      } else {
        var has_groups = this.groups.filter(
          (group) => group.item === fieldName
        );
        if (has_groups.length > 0) has_groups[0].item = "";

        has_groups = this.groups4Import.filter(
          (group) => group.item === fieldName
        );
        if (has_groups.length > 0) has_groups[0].item = "";
        this.groups4Import[index].item = fieldName;
      }
    },
  },
  setup(props, context) {
    const realestateFieldMapModalRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);
    const reset = ref(0);
    const groups = ref([
      {
        name: "FullSiteAddress",
        subLabel: "(Full Site Address)",
        required: true,
        item: "",
      },
      {
        name: "SiteAddressHouseNumber",
        subLabel: "(Site Address House Number)",
        required: false,
        item: "",
      },
      {
        name: "SiteAddressStreetPrefix",
        subLabel: "(Site Address Street Prefix)",
        required: false,
        item: "",
      },
      {
        name: "SiteAddressStreetName",
        subLabel: "(Site Address Street Name)",
        required: false,
        item: "",
      },
      {
        name: "SiteAddressUnitNumber",
        subLabel: "(Site Address Unit Number)",
        required: false,
        item: "",
      },
      {
        name: "SiteAddressCity",
        subLabel: "(Site Address City)",
        required: false,
        item: "",
      },
      {
        name: "SiteAddressState",
        subLabel: "(Site Address State)",
        required: false,
        item: "",
      },
      {
        name: "SiteAddressZip",
        subLabel: "(Site Address Zip)",
        required: false,
        item: "",
      },
      {
        name: "SiteAddress+4",
        subLabel: "(Site Address +4)",
        required: false,
        item: "",
      },
      {
        name: "SiteCarrierRoute",
        subLabel: "(Site Carrier Route)",
        required: false,
        item: "",
      },
      {
        name: "Owner1FirstName",
        subLabel: "(Owner 1 First Name)",
        required: false,
        item: "",
      },
      {
        name: "Owner1MiddleName",
        subLabel: "(Owner 1 Middle Name)",
        required: false,
        item: "",
      },
      {
        name: "Owner1LastName",
        subLabel: "(Owner 1 Last Name)",
        required: false,
        item: "",
      },
      {
        name: "Owner1SpouseFirstName",
        subLabel: "(Owner 1 Spouse First Name)",
        required: false,
        item: "",
      },
      {
        name: "Owner2FirstName",
        subLabel: "(Owner 2 First Name)",
        required: false,
        item: "",
      },
      {
        name: "Owner2MiddleName",
        subLabel: "(Owner 2 Middle Name)",
        required: false,
        item: "",
      },
      {
        name: "Owner2LastName",
        subLabel: "(Owner 2 Last Name)",
        required: false,
        item: "",
      },
      {
        name: "Owner2SpouseFirstName",
        subLabel: "(Owner 2 Spouse First Name)",
        required: false,
        item: "",
      },
      {
        name: "MailAdressStreetNumber",
        subLabel: "(Mail Adress Street Number)",
        required: false,
        item: "",
      },
      {
        name: "MailAddressStreetPrefix",
        subLabel: "(Mail Address Street Prefix)",
        required: false,
        item: "",
      },
      {
        name: "MailAddressStreetName",
        subLabel: "(Mail Address Street Name)",
        required: false,
        item: "",
      },
      {
        name: "MailAddressUnitNumber",
        subLabel: "(Mail Address Unit Number)",
        required: false,
        item: "",
      },
      {
        name: "MailAddressCity",
        subLabel: "(Mail Address City)",
        required: false,
        item: "",
      },
      {
        name: "MailAddressState",
        subLabel: "(Mail Address State)",
        required: false,
        item: "",
      },
      {
        name: "MailAddressZip",
        subLabel: "(Mail Address Zip)",
        required: false,
        item: "",
      },
      {
        name: "MailAddress+4",
        subLabel: "(Mail Address +4)",
        required: false,
        item: "",
      },
      {
        name: "MailCarrierRoute",
        subLabel: "(Mail Carrier Route)",
        required: false,
        item: "",
      },
      {
        name: "OwnerOccupied",
        subLabel: "(Owner Occupied)",
        required: false,
        item: "",
      },
      {
        name: "UseCodeDescription",
        subLabel: "(Use Code Description)",
        required: false,
        item: "",
      },
      {
        name: "UseCodeCounty",
        subLabel: "(Use Code County)",
        required: false,
        item: "",
      },
      {
        name: "Zoning",
        subLabel: "(Zoning)",
        required: false,
        item: "",
      },
      {
        name: "BuildingSqft",
        subLabel: "(Building Sqft)",
        required: false,
        item: "",
      },
      {
        name: "Rooms",
        subLabel: "(Rooms)",
        required: false,
        item: "",
      },
      {
        name: "Bedrooms",
        subLabel: "(Bedrooms)",
        required: false,
        item: "",
      },
      {
        name: "Bathrooms",
        subLabel: "(Bathrooms)",
        required: false,
        item: "",
      },
      {
        name: "Pool",
        subLabel: "(Pool)",
        required: false,
        item: "",
      },
      {
        name: "NumberofStories",
        subLabel: "(Number of Stories)",
        required: false,
        item: "",
      },
      {
        name: "NumberofUnits",
        subLabel: "(Number of Units)",
        required: false,
        item: "",
      },
      {
        name: "SalesPrice",
        subLabel: "(Sales Price)",
        required: false,
        item: "",
      },
      {
        name: "SalesPriceCode",
        subLabel: "(Sales Price Code)",
        required: false,
        item: "",
      },
      {
        name: "SaleDate",
        subLabel: "(Sale Date)",
        required: false,
        item: "",
      },
      {
        name: "SalesDocumentNumber",
        subLabel: "(Sales Document Number)",
        required: false,
        item: "",
      },
      {
        name: "AssessedLandValue",
        subLabel: "(Assessed Land Value)",
        required: false,
        item: "",
      },
      {
        name: "AssessedImprovePercent",
        subLabel: "(Assessed Improve Percent)",
        required: false,
        item: "",
      },
      {
        name: "AssessedImprovementValue",
        subLabel: "(Assessed Improvement Value)",
        required: false,
        item: "",
      },
      {
        name: "EstValue",
        subLabel: "(Est Value)",
        required: false,
        item: "",
      },
      {
        name: "EstEquity",
        subLabel: "(Est Equity $)",
        required: false,
        item: "",
      },
      {
        name: "ListedforSale",
        subLabel: "(Listed for Sale ?)",
        required: false,
        item: "",
      },
      {
        name: "PrimaryPhone1",
        subLabel: "(Primary Phone 1)",
        required: false,
        item: "",
      },
      {
        name: "PrimaryMobilePhone1",
        subLabel: "(Primary Mobile Phone 1)",
        required: false,
        item: "",
      },
      {
        name: "PrimaryEmail1",
        subLabel: "(Primary Email 1)",
        required: false,
        item: "",
      },
      {
        name: "PrimaryPhone1Hash",
        subLabel: "(Primary Phone 1 Hash)",
        required: false,
        item: "",
      },
      {
        name: "PrimaryEmail1Hash",
        subLabel: "(Primary Email 1 Hash)",
        required: false,
        item: "",
      },
      {
        name: "SecondaryPhone1",
        subLabel: "(Secondary Phone 1)",
        required: false,
        item: "",
      },
      {
        name: "SecondaryMobilePhone1",
        subLabel: "(Secondary Mobile Phone1)",
        required: false,
        item: "",
      },
      {
        name: "SecondaryPhone1Hash",
        subLabel: "(Secondary Phone 1 Hash)",
        required: false,
        item: "",
      },
      {
        name: "SecondaryEmail1",
        subLabel: "(Secondary Email 1)",
        required: false,
        item: "",
      },
      {
        name: "SecondaryEmail1Hash",
        subLabel: "(Secondary Email 1 Hash)",
        required: false,
        item: "",
      },
      {
        name: "LotAreaAcres",
        subLabel: "(Lot Area Acres)",
        required: false,
        item: "",
      },
      {
        name: "LotAreaSQFT",
        subLabel: "(Lot Area SQFT)",
        required: false,
        item: "",
      },
      {
        name: "ParcelNumber",
        subLabel: "(Parcel Number)",
        required: false,
        item: "",
      },
      {
        name: "YearBuilt",
        subLabel: "(Year Built)",
        required: false,
        item: "",
      },
      {
        name: "GarageNumberofCars",
        subLabel: "(Garage Number of Cars)",
        required: false,
        item: "",
      },
      {
        name: "GarageType",
        subLabel: "(Garage Type)",
        required: false,
        item: "",
      },
      {
        name: "Tract",
        subLabel: "(Tract)",
        required: false,
        item: "",
      },
      {
        name: "TaxExemptionCode",
        subLabel: "(Tax Exemption Code)",
        required: false,
        item: "",
      },
      {
        name: "TaxDelinquent",
        subLabel: "(Tax Delinquent)",
        required: false,
        item: "",
      },
      {
        name: "TaxDelinquentYears",
        subLabel: "(Tax Delinquent Year(s))",
        required: false,
        item: "",
      },
      {
        name: "TaxYear",
        subLabel: "(Tax Year)",
        required: false,
        item: "",
      },
      {
        name: "View",
        subLabel: "(View)",
        required: false,
        item: "",
      },
      {
        name: "CostPerSqFt",
        subLabel: "(Cost Per SqFt)",
        required: false,
        item: "",
      },
      {
        name: "DeedType",
        subLabel: "(Deed Type)",
        required: false,
        item: "",
      },
      {
        name: "TaxArea",
        subLabel: "(Tax Area)",
        required: false,
        item: "",
      },
      {
        name: "TaxAmount",
        subLabel: "(Tax Amount)",
        required: false,
        item: "",
      },
      {
        name: "LoanAmount",
        subLabel: "(Loan Amount)",
        required: false,
        item: "",
      },
      {
        name: "LoanAmount2nd",
        subLabel: "(Loan Amount 2nd)",
        required: false,
        item: "",
      },
      {
        name: "LoanType",
        subLabel: "(Loan Type)",
        required: false,
        item: "",
      },
      {
        name: "LenderName",
        subLabel: "(Lender Name)",
        required: false,
        item: "",
      },
      {
        name: "TitleCompanyName",
        subLabel: "(Title Company Name)",
        required: false,
        item: "",
      },
      {
        name: "PriorSaleDate",
        subLabel: "(Prior Sale Date)",
        required: false,
        item: "",
      },
      {
        name: "PriorSalesPrice",
        subLabel: "(Prior Sales Price)",
        required: false,
        item: "",
      },
      {
        name: "Latitude",
        subLabel: "(Latitude)",
        required: false,
        item: "",
      },
      {
        name: "Longitude",
        subLabel: "(Longitude)",
        required: false,
        item: "",
      },
      {
        name: "SellerAgent",
        subLabel: "(Seller Agent)",
        required: false,
        item: "",
      },
      {
        name: "SellerAgentCompany",
        subLabel: "(Seller Agent Company)",
        required: false,
        item: "",
      },
      {
        name: "BuyerAgent",
        subLabel: "(Buyer Agent)",
        required: false,
        item: "",
      },
      {
        name: "BuyerAgentCompany",
        subLabel: "(Buyer Agent Company)",
        required: false,
        item: "",
      },
      {
        name: "CensusTract",
        subLabel: "(Census Tract)",
        required: false,
        item: "",
      },
    ]);
    // eslint-disable-next-line
    const groups4Import = ref<any>([]);

    const getGroups4Import = computed(() => {
      if (!props.dataFields) {
        return [];
      }

      initGroups();
      initImportFields(props.dataFields);

      if (reset.value > 0) {
        return groups4Import.value;
      }
      return autoAlign();
    });

    const initGroups = () => {
      groups.value.map((group) => {
        group.item = "";
      });
      groups.value.sort((a, b) => (a.name > b.name ? 1 : -1));
    };

    const initImportFields = (importfields) => {
      const fields = [...importfields];
      groups4Import.value.splice(0);
      fields.map((field) => {
        groups4Import.value.push({ name: field, item: field });
      });
      groups4Import.value.sort((a, b) => (a.name > b.name ? 1 : -1));
    };

    const autoAlign = () => {
      groups.value.map((group) => {
        const field = groups4Import.value.find(
          (target) => target.name === group.name
        );
        if (field) {
          group.item = field.name;
          field.item = "";
        }
      });

      return groups4Import.value;
    };

    const validate = () => {
      const missingFields = groups.value.filter(
        (group) => group.required === true && group.item == ""
      );
      if (missingFields.length > 0) {
        let errorMsg = "please fill in the required field: ";
        for (let i = 0; i < missingFields.length; i++) {
          if (i !== missingFields.length - 1) {
            errorMsg +=
              missingFields[i].name.charAt(0).toUpperCase() +
              missingFields[i].name.slice(1) +
              ", ";
          } else {
            errorMsg +=
              missingFields[i].name.charAt(0).toUpperCase() +
              missingFields[i].name.slice(1);
          }
        }

        Swal.fire({
          text: errorMsg,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });

        return false;
      }

      return true;
    };

    const handleFieldMap = () => {
      if (validate()) {
        context.emit("on-handle-field-map", groups.value);
      }
    };

    const resetFieldMap = () => {
      reset.value++;
    };

    const completedImport = () => {
      hideModal(realestateFieldMapModalRef.value);
    };

    return {
      groups,
      getGroups4Import,
      groups4Import,
      reset,
      handleFieldMap,
      resetFieldMap,
      validate,
      loading,
      realestateFieldMapModalRef,
      completedImport,
      initGroups,
      initImportFields,
    };
  },
});
